import { TFunction } from "i18next";
import i18n from "@common/i18n";

// `i18n` è la promise di init di i18next: la TFunction esiste solo dopo che si
// è risolta, quindi questo modulo la tiene in una variabile privata.
let resolved: TFunction | undefined;

i18n.then((t: TFunction) => resolved = t).catch(_ignored => { })

/**
 * TFunction per il codice fuori da React: i moduli che non sono componenti
 * (l'interceptor 401 di `RestAPI`) non possono usare `useTranslation`.
 *
 * È una funzione e non un `let` esportato perché un binding mutabile esportato
 * è riscrivibile da qualunque importatore (S6861); qui lo stato di init viene
 * letto al momento della chiamata, che è la stessa semantica di prima. Finché
 * i18next non ha risolto ripiega sulla chiave — prima, in quella finestra, il
 * chiamante andava in TypeError.
 */
export function translate(key: string, options?: Record<string, unknown>): string {
  return resolved ? resolved(key, options).toString() : key;
}
